export function formatDate(input) {
  if (!input) return "";
  // 支持传入秒或毫秒级时间戳
  const timestamp = String(input).length === 10 ? input * 1000 : input;

  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}/${month}/${day}`;
}
